import { render } from "./wasmBoxInfo.vue?vue&type=template&id=ff359da8"
import script from "./wasmBoxInfo.vue?vue&type=script&lang=js"
export * from "./wasmBoxInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__